<template>
  <el-container style="height: 100%; min-width: 800px">
    <el-main style="padding: 0 10px">
      <el-container style="height: 100%">
        <el-header>
          <Menu
            :user-info="userInfo"
            @changeUserManual="handleChangeManualStatus"
            @messageMore="handleMessageMore(personId || userId)"
          />
        </el-header>
        <el-main>
          <Message
            :user-id="userId"
            :message-list="messageList"
            @userMessage="handleUserMessage"
          />
        </el-main>
        <el-footer>
          <el-row>
            <el-col :span="21">
              <el-input
                v-model="inputMessage"
                type="textarea"
              />
            </el-col>
            <el-col :span="3">
              <el-button
                type="success"
                @click="handleSendMessage"
              >
                发送
              </el-button>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </el-main>
    <el-aside width="350px">
      <chart :risk-data="riskData"/>
      <tools
        :user-id="userId"
        :user-message="userMessage"
        :faq-list="faqList"
        @searchFaq="handleSearchFaq"
        @activeFaq="handleActiveFaq"
        @scriptGo="handleScriptGo"
      />
    </el-aside>
  </el-container>
</template>
<script>

  import Menu from './chat/Menu'
  import Message from './chat/Message'
  import Chart from "./chat/Chart"
  import Tools from "./chat/Tools"
  import { findIndex } from 'lodash'

  import LibChat from '../../minxin/Chat'

  export default {
    name: 'Chat',
    components: { Menu, Message, Chart, Tools },
    mixins: [ LibChat ],

    data () {
      return {
        inputMessage: '',
        userMessage: ''
      }
    },
    created() {
      this.initWS()
    },
    methods: {
      handleSendMessage: function () {
        if (this.userId && this.inputMessage.length > 0) {
          const user = this.userList.find(u => u.uid === this.userId)
          if (user['manual']) {
            this.sendMessage(this.userId, this.inputMessage)
            this.inputMessage = ''
          } else {
            this.$message.error('请先关闭AI自动回答')
          }
        }
      },
      handleChangeManualStatus: function (data) {
        this.sendManualStats(this.userId, data.status)
        const index = findIndex(this.userList, u => u.uid === this.userId)
        if (index > -1) {
          this.userList[index].manual = data.status
        }
      },
      handleMessageMore: function (uid) {
        if (this.messageList.length > 0) {
          this.sendMessageMore(uid, [
            this.messageList[0].index - 5,
            this.messageList[0].index - 1
          ])
        }
      },
      handleUserMessage: function (msg) {
        this.userMessage = msg.message
      },
      handleActiveFaq: function (faq) {
        this.inputMessage = faq
      },
      handleScriptGo: function (script) {
        if (this.userId > 0) {
          this.sendScript(this.userId, script)
        } else {
          this.$message.error('请先选择用户再切换场景!')
        }
      },
      handleSearchFaq: function (msg) {
        this.searchFAQ(msg)
      },
    }
  }
</script>
